import { Link } from 'react-router-dom';
import { companyName, formatQty } from '../lib/format';

const SHOWN = 8;

export default function StockAlerts({ lowStockAlerts, companyMap }) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Stock bajo mínimo</h3>
        {lowStockAlerts.length > 0 && <span className="badge badge-danger">{lowStockAlerts.length}</span>}
      </div>
      <div className="table-container">
        {lowStockAlerts.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">✅</div>
            <p>Todo el inventario está por encima del mínimo</p>
          </div>
        ) : (
          <table>
            <thead><tr><th>Producto</th><th>Tienda</th><th className="num">Stock / mín.</th></tr></thead>
            <tbody>
              {lowStockAlerts.slice(0, SHOWN).map((p) => (
                <tr key={`${p.companyId}/${p.id}`}>
                  <td className="font-semibold">{p.name || 'Sin nombre'}</td>
                  <td>
                    <Link className="table-link" to={`/companies/${p.companyId}`}>
                      {companyName(companyMap[p.companyId] || { id: p.companyId })}
                    </Link>
                  </td>
                  <td className="num">
                    <span className={(p.stock || 0) <= 0 ? 'text-danger font-bold' : 'text-warning font-bold'}>{formatQty(p.stock)}</span>
                    <span className="text-muted"> / {formatQty(p.minStock ?? 5)}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {lowStockAlerts.length > SHOWN && (
          <p className="table-footnote">y {lowStockAlerts.length - SHOWN} más. Abre cada tienda para ver su lista completa.</p>
        )}
      </div>
    </div>
  );
}
